import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

import commonAPI from './services/commonAPI';
import dashboardAPI from './services/dashboardAPI';
import leaveRequestsAPI from './services/leaveRequestsAPI';
import adminDashboardAPI from './services/adminDashboardAPI';
import administrationAPI from './services/administrationAPI';
import leaveAllocationAPI from './services/leaveAllocationAPI';
import holidayCalendarAPI from './services/holidayCalendarAPI';
import staffAttendanceAPI from './services/staffAttendanceAPI';
import instituteLocationAPI from './services/instituteLocationAPI';
import leaveConfigurationAPI from './services/leaveConfigurationAPI';
import departmentLeaveReportAPI from './services/departmentLeaveReportAPI';

import {
  profileAPI,
  contactUpdateAPI,
  CommonAPI,
  menuAPI,
  NotificationAPI
} from "@gyandiksha/shared-ui/app/services";

const appReducer = (state = {}) => state;

export const store = configureStore({
  reducer: {
    app: appReducer,
    [administrationAPI.reducerPath]: administrationAPI.reducer,
    [holidayCalendarAPI.reducerPath]: holidayCalendarAPI.reducer,
    [leaveConfigurationAPI.reducerPath]: leaveConfigurationAPI.reducer,
    [leaveRequestsAPI.reducerPath]: leaveRequestsAPI.reducer,
    [profileAPI.reducerPath]: profileAPI.reducer,
    [contactUpdateAPI.reducerPath]: contactUpdateAPI.reducer,
    [CommonAPI.reducerPath]: CommonAPI.reducer,
    [dashboardAPI.reducerPath]: dashboardAPI.reducer,
    [adminDashboardAPI.reducerPath]: adminDashboardAPI.reducer,
    [commonAPI.reducerPath]: commonAPI.reducer,
    [departmentLeaveReportAPI.reducerPath]: departmentLeaveReportAPI.reducer,
    [leaveAllocationAPI.reducerPath]: leaveAllocationAPI.reducer,
    [staffAttendanceAPI.reducerPath]: staffAttendanceAPI.reducer,
    [menuAPI.reducerPath]: menuAPI.reducer,
    [instituteLocationAPI.reducerPath]: instituteLocationAPI.reducer,
    [NotificationAPI.reducerPath]: NotificationAPI.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      administrationAPI.middleware,
      holidayCalendarAPI.middleware,
      leaveConfigurationAPI.middleware,
      leaveRequestsAPI.middleware,
      profileAPI.middleware,
      contactUpdateAPI.middleware,
      CommonAPI.middleware,
      dashboardAPI.middleware,
      adminDashboardAPI.middleware,
      commonAPI.middleware,
      departmentLeaveReportAPI.middleware,
      leaveAllocationAPI.middleware,
      staffAttendanceAPI.middleware,
      menuAPI.middleware,
      instituteLocationAPI.middleware,
      NotificationAPI.middleware,
    ),
});

setupListeners(store.dispatch);
